export default "__VITE_ASSET__D5xRZIJw__"